module.exports = __webpack_public_path__ + "img/web-hidayatullah.1c35e666.jpg";